import AWS from 'aws-sdk';

export async function uploadImage(e) {
    AWS.config.region = process.env.AWS_REGION; // Region
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: process.env.AWS_COGNITO_IDENTITY_POOL,
    });

    var s3Bucket = new AWS.S3({
        params: { Bucket: process.env.S3_BUCKET },
    });
    let newDate = new Date();
    let day = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    let time = newDate.getTime();
    if (month < 10) {
        month = '0' + month;
    }
    let date = year + '/' + month + '/' + day;

    let typesplit = e.target.files[0].type.split('/');
    let imageType = typesplit[1];
    let finalkey = date + '/img-' + time + '.' + imageType;

    let image = await new Promise((resolve, reject) => {
        s3Bucket.upload(
            {
                Key: finalkey,
                Body: e.target.files[0],
                ContentType: e.target.files[0].type,
            },
            function(err, data) {
                if (err) {
                    reject(err);
                }
                if (data) {
                    resolve(data);
                }
            },
        );
    }).then(() => {
        return process.env.LITTERATI_CDN_URL + '/' + finalkey;
    });
    return image;
}

export async function uploadCsv(file) {
    AWS.config.region = process.env.AWS_REGION || 'us-west-2'; // Region
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId:
            process.env.AWS_COGNITO_IDENTITY_POOL ||
            'us-west-2:8f19e2d6-6b9e-4f36-bf63-f8822bbd1f91',
    });

    var s3Bucket = new AWS.S3({
        params: { Bucket: process.env.S3_BUCKET || 'litterati-images-dev' },
    });
    //https://litterati-images-dev.s3-us-west-2.amazonaws.com/
    let csv = await new Promise((resolve, reject) => {
        s3Bucket.upload(
            {
                Key: `report-management/${file.name}`,
                Body: file,
                ContentType: file.type,
            },
            function(err, data) {
                if (err) {
                    reject(err);
                }
                if (data) {
                    resolve(data);
                }
            },
        );
    }).then(() => {
        return `${process.env.LITTERATI_CDN_URL}/report-management/${file.name}`;
    });
    return csv;
}
